import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AttachListComponent } from './attach-list/attach-list.component';
import { VisitorsListComponent } from './visitors-list/visitors-list.component';
import { ScheduleVisitorComponent } from './schedule-visitor/schedule-visitor.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'schedule-vistor',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'attachList',
    component: AttachListComponent
  },
  {
    path: 'visitors',
    component: VisitorsListComponent
  },
  {
    path: 'schedule-vistor',
    component: ScheduleVisitorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],

  exports: [RouterModule]
})
export class AppRoutingModule { }
